<ng-container *transloco="let t">
  <div class="d-flex justify-content-between align-items-center p-4">
    <p class="text-uppercase fst-normal"> {{t('app.share.with')}} </p>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="px-4 pb-4">
    <app-share-cta [item]="this.eventItem" [isShareVisible]="this.isShareVisible"/>
  </div>
</ng-container>
